import { Alert, ConfirmDialog, Modal } from "@nabble/ui";
import type { AdminDataRequest } from "../../../api/adminDataRequests";
import { KIND_LABEL_ADMIN, STATUS_LABEL } from "../../../model/dataRequests";
import { AnswerFields } from "./AnswerFields";
import { ExtensionField } from "./ExtensionField";
import { RequestDetails } from "./RequestDetails";
import { requestDrawerActions } from "./requestDrawerActions";
import { useRequestDrawer } from "./useRequestDrawer";

interface RequestDrawerProps {
  request: AdminDataRequest;
  onClose: () => void;
  onChanged: () => void;
}

/** One data request: read it, mark it in progress, extend its deadline once or answer it. */
export function RequestDrawer({ request: r, onClose, onChanged }: RequestDrawerProps): React.JSX.Element {
  const drawer = useRequestDrawer(r, onChanged);

  return (
    <>
      <Modal
        open
        variant="drawer"
        icon="shield"
        title={KIND_LABEL_ADMIN[r.kind]}
        description={`${r.userName} · ${r.userEmail}`}
        onClose={onClose}
        actions={requestDrawerActions({ request: r, drawer })}
      >
        <div className="nb-stack">
          <RequestDetails request={r} />
          {drawer.mode === "answer" ? <AnswerFields drawer={drawer} /> : null}
          {drawer.mode === "extend" ? <ExtensionField drawer={drawer} /> : null}
          {drawer.error ? <Alert tone="danger">{drawer.error}</Alert> : null}
        </div>
      </Modal>

      <ConfirmDialog
        open={drawer.confirming}
        tone={drawer.outcome === "REJECTED" ? "warning" : "default"}
        icon="send"
        title={drawer.outcome === "DONE" ? "Send the answer?" : "Send the refusal?"}
        description={`${r.userName} will receive your answer by email and the request will be marked as ${STATUS_LABEL[drawer.outcome].toLowerCase()}. This can't be undone.`}
        confirmLabel="Send answer"
        onClose={drawer.cancelConfirm}
        onConfirm={() => drawer.answer()}
      />
    </>
  );
}
